import Welcome from '../scenes/Welcome';
import CharacterSelect from '../scenes/CharacterSelect';
import ConfirmAction from '../scenes/ConfirmAction';
import CutScene from '../scenes/CutScene';
import GameOver from '../scenes/GameOver';
import GamePlay from '../scenes/GamePlay';
import StageComplete from '../scenes/StageComplete';
import ItemUnlocks from '../scenes/ItemUnlocks';
import StoryComplete from '../scenes/StoryComplete';
import EnemyViewer from '../scenes/EnemyViewer';
import LevelComplete from '../scenes/LevelComplete';
import CombatTest from '../scenes/CombatTest';
import Pause from '../scenes/Pause';

export const KEYS = {
  Welcome: 'Welcome',
  CutScene: 'CutScene',
  CharacterSelect: 'CharacterSelect',
  GamePlay: 'GamePlay',
  GameOver: 'GameOver',
  StageComplete: 'StageComplete',
  ConfirmAction: 'ConfirmAction',
  ItemUnlocks: 'ItemUnlocks',
  StoryComplete: 'StoryComplete',
  EnemyViewer: 'EnemyViewer',
  LevelComplete: 'LevelComplete',
  CombatTest: 'CombatTest',
  Pause: 'Pause',
};

export const SCENE_MAP = [
  { key: KEYS.Welcome, state: Welcome },
  { key: KEYS.CutScene, state: CutScene },
  { key: KEYS.CharacterSelect, state: CharacterSelect },
  { key: KEYS.GamePlay, state: GamePlay },
  { key: KEYS.GameOver, state: GameOver },
  { key: KEYS.StageComplete, state: StageComplete },
  { key: KEYS.ConfirmAction, state: ConfirmAction },
  { key: KEYS.ItemUnlocks, state: ItemUnlocks },
  { key: KEYS.StoryComplete, state: StoryComplete },
  { key: KEYS.EnemyViewer, state: EnemyViewer },
  { key: KEYS.LevelComplete, state: LevelComplete },
  { key: KEYS.CombatTest, state: CombatTest },
  { key: KEYS.Pause, state: Pause },
];
